import React from "react";
export const Info = ({
  size = 24,
  color = "currentColor",
  strokeWidth = 1.5,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M11.009 11.249H12.159V15.499"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15.4986H13.3093"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1 8.24587C12.1 8.29532 12.0853 8.34365 12.0579 8.38477C12.0304 8.42588 11.9914 8.45792 11.9457 8.47684C11.9 8.49576 11.8497 8.50071 11.8012 8.49107C11.7527 8.48142 11.7082 8.45761 11.6732 8.42265C11.6383 8.38769 11.6145 8.34314 11.6048 8.29464C11.5952 8.24615 11.6001 8.19588 11.619 8.1502C11.638 8.10452 11.67 8.06548 11.7111 8.03801C11.7522 8.01053 11.8006 7.99587 11.85 7.99587"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.85 7.99587C11.9163 7.99587 11.9799 8.02221 12.0268 8.0691C12.0737 8.11598 12.1 8.17957 12.1 8.24587"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2.99862H8C5.23858 2.99862 3 5.2372 3 7.99862V15.9986C3 18.76 5.23858 20.9986 8 20.9986H16C18.7614 20.9986 21 18.76 21 15.9986V7.99862C21 5.2372 18.7614 2.99862 16 2.99862Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
